import { render, staticRenderFns } from "./addIndexModel.vue?vue&type=template&id=0b26694b&"
import script from "./addIndexModel.vue?vue&type=script&lang=js&"
export * from "./addIndexModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports